module.exports = __webpack_public_path__ + "img/raytracing.eba02705.png";